<template>

  <div dir="ltr" class="mt-3 nav310">

    <b-dropdown :text="item.name" variant="transparent" class="drop-down-head-button nav-btn"
                v-if="item.children.length!==0">

      <b-nav-item class="mt-3 nav310-drop-down-item-color text-decoration-none font-weight-bold"
                  :href="child.url" v-for="child in item.children" :key="child.id">
        {{ child.name }}
        <m-icon class="m-0" :icon="child.icon_class"/>

      </b-nav-item>

    </b-dropdown>

    <b-nav-item :href="item.url" class="px-1  text-decoration-none font-weight-bold mt-1  nav-btn" v-else>
      {{ item.name }}
      <m-icon class="m-0 nav-item-icon" :icon="item.icon_class"/>
    </b-nav-item>

  </div>

</template>

<script>

export default {
  name: "NavMenuItem",
  props: ['item'],
}
</script>

<style>
.drop-down-head-button .dropdown-menu {
  background: var(--primary);
  color: white;
  border-radius: 15px;
}

.nav310-drop-down-item-color .nav-link {
  text-align: center;
}

.nav310 .nav-btn, .nav310 .nav-btn .btn {
  background: var(--primary) !important;
  color: var(--light-cyan) !important;
  border-radius: 20px;
  transition: all .2s ease-in-out;
}

</style>

<style scoped>
a {
  text-decoration: none !important;
  color: var(--light-cyan) !important;
}

li {
  list-style: none !important;
  color: var(--light-cyan) !important;
}

.nav-item-icon {
  color: var(--light-cyan) !important;
}

.nav-btn:hover {
  background: var(--secondary) !important;
  color: var(--light-cyan) !important;
  border-radius: 20px;
  transition: all .2s ease-in-out;
}

.drop-down-head-button {
  color: var(--light-cyan) !important;
}

</style>